import { useQuery } from "@tanstack/react-query";
import { communityApi } from "@bw/shared/api";
import type { CommentListResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * A post's comment thread (GET /communities/posts/{id}/comments), returned
 * VERBATIM as the server's `{items, total}` envelope of CommentResponse. The
 * page renders each comment — author by display_name, content as plain text,
 * the server's timestamp. No client sort, no nesting math (the server owns
 * depth / order). No derived state.
 *
 * Disabled until an id is present so an unresolved route param never fires a
 * bogus request. Cached under its OWN `social.post-comments(id)` slot, DISTINCT
 * from the `social.post(id)` slot, so the post and its thread load independently.
 * Read-only (Slice 2); no comment write invalidates it yet.
 */
export function usePostComments(postId: string | undefined) {
  return useQuery<CommentListResponse>({
    queryKey: queryKeys.social.postComments(postId ?? ""),
    queryFn: () => communityApi.listPostComments(postId as string),
    enabled: Boolean(postId),
  });
}
